import { render, staticRenderFns } from "./AppIndicator.vue?vue&type=template&id=20da25de&scoped=true&"
import script from "./AppIndicator.vue?vue&type=script&lang=js&"
export * from "./AppIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20da25de",
  null
  
)

export default component.exports